import React from "react"
import { useTotalRootPoolsTVL } from "../../../hooks/useTotalRootPoolsTVL"

function Stats({ data, rootPools }) {
    // console.log(data, rootPools, 'statdata')

    // Get total TVL from all root pools
    const { totalTVL, totalTVLUSD, loading: tvlLoading, error: tvlError } = useTotalRootPoolsTVL(rootPools)

    // Helper function to format numbers as 10K, 10M, 10B, etc.
    const formatNumber = (num) => {
        if (num === null || num === undefined) return "0"
        if (num >= 1e12) return (num / 1e12).toFixed(2).replace(/\.0+$/, '') + "T"
        if (num >= 1e9) return (num / 1e9).toFixed(2).replace(/\.0+$/, '') + "B"
        if (num >= 1e6) return (num / 1e6).toFixed(2).replace(/\.0+$/, '') + "M"
        if (num >= 1e3) return (num / 1e3).toFixed(2).replace(/\.0+$/, '') + "K"
        return num.toLocaleString()
    }

    const stats = [
        {
            label: "TVL",
            value: (totalTVLUSD ? totalTVLUSD : data?.TVL) ||  0,
            isCurrency: true,
            isLoading: tvlLoading
        },
        { label: "No. of Farms", value: data?.[0]?.farms ?? 0 },
        { label: "Pools Created", value: data?.[0]?.pools ?? 0 },
        { label: "No. of Stakers", value: data?.[0]?.stakers ?? 0 },
    ]

    return (
        <div className="boootom_Side">
            {stats.map(({ label, value, isCurrency, isLoading }, index) => (
                <div className="sides" key={index}>
                    <p>{label}</p>
                    <h4>
                        {isLoading ? (
                            "Loading..."
                        ) : isCurrency ? (
                            `$${formatNumber(value)}`
                        ) : (
                            formatNumber(value)
                        )}
                    </h4>
                </div>
            ))}
        </div>
    )
}

export default Stats